import React, { useState } from 'react';
import Modal from './Modal';
import axios from 'axios';
import { toast } from 'react-toastify';
import Form from '../Form/Form';
import InputText from '../Form/Fields/InputText';
import Textarea from '../Form/Fields/Textarea';
import InputLaboratory from '../Form/Fields/InputLaboratory';
import Select from '../Form/Fields/Select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPills, faChevronDown, faChevronUp, faTimes, faImage } from '@fortawesome/free-solid-svg-icons';
import Button from '../Form/Button';
import { API_BASE_URL } from '../../api';

import './CreateProductModal.scss';

const STATUS_OPTIONS = [
  { value: 'MARKETED', label: 'Commercialisé' },
  { value: 'NOT_MARKETED', label: 'Non commercialisé' },
];

const REFUNDABLE_OPTIONS = [
  { value: 'false', label: 'Non remboursable' },
  { value: 'true', label: 'Remboursable' },
];

// FR fields with a matching *Ar counterpart in ProductTranslation — everything else
// (barcode, prices, status, laboratory, atcCode...) is a single global value, not translatable.
function TranslatableFields({ lang }) {
  const hidden = { display: lang === 'fr' ? 'none' : 'block' };
  const shown = { display: lang === 'fr' ? 'block' : 'none' };

  return (
    <>
      <div style={shown}>
        <div className="mt-2">
          <label className="cdm-field-label">Nom <span className="text-danger">*</span></label>
          <InputText name="name" placeholder="Nom du produit" validationRules={{ required: 'Le nom est requis' }} />
        </div>
        <div className="cdm-grid-2 mt-2">
          <div>
            <label className="cdm-field-label">Présentation</label>
            <InputText name="presentation" placeholder="Comprimé, Sirop..." />
          </div>
          <div>
            <label className="cdm-field-label">Dosage</label>
            <InputText name="dosage" placeholder="20 MG" />
          </div>
        </div>
        <div className="mt-2">
          <label className="cdm-field-label">Famille</label>
          <InputText name="family" placeholder="Famille thérapeutique" />
        </div>
        <div className="mt-2">
          <label className="cdm-field-label">Composition</label>
          <Textarea name="composition" placeholder="Composition du produit..." />
        </div>
        <div className="mt-2">
          <label className="cdm-field-label">Indication</label>
          <Textarea name="indication" placeholder="Indications thérapeutiques..." />
        </div>
        <div className="mt-2">
          <label className="cdm-field-label">Posologie</label>
          <Textarea name="dosagesAdministration" placeholder="Posologie et mode d'administration..." />
        </div>
        <div className="mt-2">
          <label className="cdm-field-label">Contre-indications</label>
          <Textarea name="contraindication" placeholder="Contre-indications..." />
        </div>
        <div className="mt-2">
          <label className="cdm-field-label">Mises en garde</label>
          <Textarea name="warnings" placeholder="Mises en garde et précautions d'emploi..." />
        </div>
      </div>

      <div style={hidden} dir="rtl">
        <div className="mt-2">
          <label className="cdm-field-label">الاسم</label>
          <InputText name="nameAr" placeholder="اسم المنتج" />
        </div>
        <div className="cdm-grid-2 mt-2">
          <div>
            <label className="cdm-field-label">الشكل</label>
            <InputText name="presentationAr" />
          </div>
          <div>
            <label className="cdm-field-label">الجرعة</label>
            <InputText name="dosageAr" />
          </div>
        </div>
        <div className="mt-2">
          <label className="cdm-field-label">العائلة</label>
          <InputText name="familyAr" />
        </div>
        <div className="mt-2">
          <label className="cdm-field-label">التركيب</label>
          <Textarea name="compositionAr" />
        </div>
        <div className="mt-2">
          <label className="cdm-field-label">دواعي الاستعمال</label>
          <Textarea name="indicationAr" />
        </div>
        <div className="mt-2">
          <label className="cdm-field-label">طريقة الاستعمال</label>
          <Textarea name="dosagesAdministrationAr" />
        </div>
        <div className="mt-2">
          <label className="cdm-field-label">موانع الاستعمال</label>
          <Textarea name="contraindicationAr" />
        </div>
        <div className="mt-2">
          <label className="cdm-field-label">تحذيرات</label>
          <Textarea name="warningsAr" />
        </div>
      </div>
    </>
  );
}

function ImageManager({ images, onDeleteExisting, pendingFiles, onAddPending, onRemovePending }) {
  return (
    <div className="cdm-section">
      <p className="cdm-section__label">Images</p>
      <div className="d-flex flex-wrap gap-2 mb-2">
        {images.map((img) => (
          <div key={img.id} style={{ position: 'relative', width: 72, height: 72 }}>
            <img src={img.url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 8, border: '1px solid #e5e7eb' }} />
            <button
              type="button"
              onClick={() => onDeleteExisting(img.id)}
              style={{
                position: 'absolute', top: -6, right: -6, width: 20, height: 20, borderRadius: '50%',
                background: '#dc2626', color: '#fff', border: 'none', fontSize: 10, lineHeight: '20px',
              }}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
        ))}
        {pendingFiles.map((file, i) => (
          <div key={i} style={{ position: 'relative', width: 72, height: 72 }}>
            <img src={URL.createObjectURL(file)} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 8, border: '1px dashed #2563eb' }} />
            <button
              type="button"
              onClick={() => onRemovePending(i)}
              style={{
                position: 'absolute', top: -6, right: -6, width: 20, height: 20, borderRadius: '50%',
                background: '#dc2626', color: '#fff', border: 'none', fontSize: 10, lineHeight: '20px',
              }}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
        ))}
      </div>
      <label className="btn btn-outline-secondary btn-sm" style={{ cursor: 'pointer' }}>
        <FontAwesomeIcon icon={faImage} className="me-2" />
        Ajouter des images
        <input
          type="file"
          accept="image/*"
          multiple
          hidden
          onChange={(e) => {
            onAddPending(Array.from(e.target.files || []));
            e.target.value = '';
          }}
        />
      </label>
    </div>
  );
}

function BackofficeProductFormContent({ images, onDeleteExisting, pendingFiles, onAddPending, onRemovePending }) {
  const [showMore, setShowMore] = useState(false);
  const [lang, setLang] = useState('fr');

  return (
    <>
      <div className="cdm-section">
        <div className="d-flex justify-content-between align-items-center">
          <p className="cdm-section__label mb-0">Informations</p>
          <div className="btn-group btn-group-sm">
            <button type="button" className={`btn btn-outline-secondary${lang === 'fr' ? ' active' : ''}`} onClick={() => setLang('fr')}>Français</button>
            <button type="button" className={`btn btn-outline-secondary${lang === 'ar' ? ' active' : ''}`} onClick={() => setLang('ar')}>العربية</button>
          </div>
        </div>

        <TranslatableFields lang={lang} />

        <div className="cdm-grid-2 mt-2">
          <div>
            <label className="cdm-field-label">Fabricant</label>
            <InputText name="manufacturer" placeholder="Fabricant" />
          </div>
          <div>
            <label className="cdm-field-label">Code-barres</label>
            <InputText name="barcode" placeholder="611 ***** *****" />
          </div>
        </div>

        <div className="cdm-grid-2 mt-2">
          <div>
            <label className="cdm-field-label">Prix <span className="text-danger">*</span></label>
            <div className="cdm-price-wrapper">
              <InputText name="publicPrice" placeholder="0.00" validationRules={{ required: 'Le prix est requis' }} />
              <span className="cdm-price-badge">Dhs</span>
            </div>
          </div>
          <div>
            <label className="cdm-field-label">Prix hospitalier</label>
            <div className="cdm-price-wrapper">
              <InputText name="hospitalPrice" placeholder="0.00" />
              <span className="cdm-price-badge">Dhs</span>
            </div>
          </div>
        </div>

        <div className="cdm-grid-2 mt-2">
          <div>
            <label className="cdm-field-label">Statut</label>
            <Select name="status" options={STATUS_OPTIONS} placeholder="Choisir un statut..." />
          </div>
          <div>
            <label className="cdm-field-label">Remboursement</label>
            <Select name="refundable" options={REFUNDABLE_OPTIONS} placeholder="Remboursable ?" />
          </div>
        </div>

        <div className="mt-2">
          <label className="cdm-field-label">Seuil d'alerte stock</label>
          <InputText name="minimumStock" type="number" placeholder="0" />
        </div>

        <div className="mt-2">
          <label className="cdm-field-label">Laboratoire</label>
          <InputLaboratory name="laboratoryId" />
        </div>
      </div>

      <div className="cdm-section">
        <button type="button" className="cdm-optional-toggle" onClick={() => setShowMore((prev) => !prev)}>
          <FontAwesomeIcon icon={showMore ? faChevronUp : faChevronDown} />
          {showMore ? 'Masquer les informations complémentaires' : 'Informations complémentaires'}
        </button>

        {showMore && (
          <>
            <div className="cdm-grid-2 mt-2">
              <div>
                <label className="cdm-field-label">Type produit</label>
                <InputText name="productType" />
              </div>
              <div>
                <label className="cdm-field-label">Code ATC</label>
                <InputText name="atcCode" />
              </div>
            </div>

            <div className="cdm-grid-2 mt-2">
              <div>
                <label className="cdm-field-label">Tableau</label>
                <InputText name="tableLetter" />
              </div>
              <div>
                <label className="cdm-field-label">Dépendance</label>
                <InputText name="dependanceRisk" />
              </div>
            </div>

            <div className="mt-2">
              <label className="cdm-field-label">Substance psychoactive</label>
              <InputText name="psychoactiveSubstance" />
            </div>
          </>
        )}
      </div>

      <ImageManager
        images={images}
        onDeleteExisting={onDeleteExisting}
        pendingFiles={pendingFiles}
        onAddPending={onAddPending}
        onRemovePending={onRemovePending}
      />
    </>
  );
}

export default function BackofficeProductModal({ product, show, onClose, onSave }) {
  const isEdit = !!product;
  const [isLoading, setIsLoading] = useState(false);
  const [images, setImages] = useState(product?.images || []);
  const [pendingFiles, setPendingFiles] = useState([]);

  if (!show) return null;

  const defaultValues = {
    name: product?.name || '',
    nameAr: product?.nameAr || '',
    barcode: product?.barcode || '',
    publicPrice: product?.publicPrice ?? '',
    hospitalPrice: product?.hospitalPrice ?? '',
    minimumStock: product?.minimumStock ?? '',
    presentation: product?.presentation || '',
    presentationAr: product?.presentationAr || '',
    dosage: product?.dosage || '',
    dosageAr: product?.dosageAr || '',
    manufacturer: product?.manufacturer || '',
    status: product?.status || 'MARKETED',
    refundable: product?.refundable == null ? '' : String(product.refundable),
    laboratoryId: product?.laboratoryId || null,
    family: product?.family || '',
    familyAr: product?.familyAr || '',
    productType: product?.productType || '',
    atcCode: product?.atcCode || '',
    tableLetter: product?.tableLetter || '',
    composition: product?.composition || '',
    compositionAr: product?.compositionAr || '',
    indication: product?.indication || '',
    indicationAr: product?.indicationAr || '',
    dosagesAdministration: product?.dosagesAdministration || '',
    dosagesAdministrationAr: product?.dosagesAdministrationAr || '',
    contraindication: product?.contraindication || '',
    contraindicationAr: product?.contraindicationAr || '',
    warnings: product?.warnings || '',
    warningsAr: product?.warningsAr || '',
    dependanceRisk: product?.dependanceRisk || '',
    psychoactiveSubstance: product?.psychoactiveSubstance || '',
  };

  const uploadPendingFiles = async (productId) => {
    if (pendingFiles.length === 0) return;
    const formData = new FormData();
    pendingFiles.forEach((f) => formData.append('files', f));
    await axios.post(`${API_BASE_URL}/api/v1/backoffice/products/${productId}/media`, formData, {
      withCredentials: true,
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  };

  const onSubmit = async (data) => {
    setIsLoading(true);
    const payload = {
      name: data.name,
      nameAr: data.nameAr || null,
      barcode: data.barcode || null,
      publicPrice: data.publicPrice || null,
      status: data.status || null,
      presentation: data.presentation || null,
      presentationAr: data.presentationAr || null,
      refundable: data.refundable === 'true' ? true : data.refundable === 'false' ? false : null,
      dosage: data.dosage || null,
      dosageAr: data.dosageAr || null,
      manufacturer: data.manufacturer || null,
      laboratoryId: data.laboratoryId || null,
      family: data.family || null,
      familyAr: data.familyAr || null,
      productType: data.productType || null,
      hospitalPrice: data.hospitalPrice || null,
      minimumStock: data.minimumStock || null,
      atcCode: data.atcCode || null,
      tableLetter: data.tableLetter || null,
      indication: data.indication || null,
      indicationAr: data.indicationAr || null,
      composition: data.composition || null,
      compositionAr: data.compositionAr || null,
      dosagesAdministration: data.dosagesAdministration || null,
      dosagesAdministrationAr: data.dosagesAdministrationAr || null,
      contraindication: data.contraindication || null,
      contraindicationAr: data.contraindicationAr || null,
      warnings: data.warnings || null,
      warningsAr: data.warningsAr || null,
      dependanceRisk: data.dependanceRisk || null,
      psychoactiveSubstance: data.psychoactiveSubstance || null,
    };

    try {
      const response = isEdit
        ? await axios.put(`${API_BASE_URL}/api/v1/backoffice/products/${product.id}`, payload, { withCredentials: true })
        : await axios.post(`${API_BASE_URL}/api/v1/backoffice/products`, payload, { withCredentials: true });

      await uploadPendingFiles(response.data.id);

      onClose();
      toast.success(isEdit ? 'Produit modifié avec succès !' : 'Produit créé avec succès !');
      onSave?.();
    } catch (error) {
      console.error('Error saving product:', error);
      toast.error(error.response?.data?.message || "Erreur lors de l'enregistrement du produit");
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteExistingImage = (mediaId) => {
    axios.delete(`${API_BASE_URL}/api/v1/backoffice/products/media/${mediaId}`, { withCredentials: true })
      .then(() => setImages((prev) => prev.filter((img) => img.id !== mediaId)))
      .catch(() => toast.error("Erreur lors de la suppression de l'image"));
  };

  return (
    <Modal
      id="backofficeProductModal"
      show={show}
      onClose={onClose}
      title={isEdit ? `Modifier — ${product.name}` : 'Nouveau produit'}
      icon={faPills}
      iconBg="#e0f2fe"
      iconColor="#0284c7"
      footer={
        <Button isLoading={isLoading} loadingMessage="Enregistrement..." type="submit" form="backofficeProductForm" className="btn btn-primary">
          {isEdit ? 'Enregistrer les modifications' : 'Créer le produit'}
        </Button>
      }
    >
      <Form id="backofficeProductForm" onSubmit={onSubmit} defaultValues={defaultValues}>
        <BackofficeProductFormContent
          images={images}
          onDeleteExisting={handleDeleteExistingImage}
          pendingFiles={pendingFiles}
          onAddPending={(files) => setPendingFiles((prev) => [...prev, ...files])}
          onRemovePending={(index) => setPendingFiles((prev) => prev.filter((_, i) => i !== index))}
        />
      </Form>
    </Modal>
  );
}
